import { useLang } from "../i18n";
import { Reveal, Eyebrow } from "./common";

const PHOTOS = [
    { src: "/obras/obra-1.jpg", idx: 0, span: "md:col-span-4", h: "h-[320px] md:h-[380px]" },
    { src: "/obras/obra-2.jpg", idx: 1, span: "md:col-span-4", h: "h-[320px] md:h-[380px]" },
    { src: "/obras/obra-3.jpg", idx: 2, span: "md:col-span-4", h: "h-[320px] md:h-[380px]" },
    { src: "/obras/obra-4.jpg", idx: 3, span: "md:col-span-7", h: "h-[320px] md:h-[440px]" },
    { src: "/obras/obra-5.jpg", idx: 4, span: "md:col-span-5", h: "h-[320px] md:h-[440px]" },
];

export default function Gallery() {
    const { t } = useLang();

    return (
        <section id="obras" data-testid="gallery-section" className="relative py-24 md:py-32 bg-deep overflow-hidden">
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <Reveal className="mb-14 max-w-2xl">
                    <Eyebrow>{t.gallery.eyebrow}</Eyebrow>
                    <h2 className="mt-4 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
                        {t.gallery.title}
                    </h2>
                    <p className="mt-4 text-slate-400">{t.gallery.sub}</p>
                </Reveal>

                <div className="grid md:grid-cols-12 gap-5">
                    {PHOTOS.map((p, i) => (
                        <Reveal
                            key={p.src}
                            delay={i * 0.08}
                            className={`${p.span} h-full`}
                        >
                            <figure
                                data-testid={`gallery-photo-${i + 1}`}
                                className={`group relative overflow-hidden rounded-2xl border border-white/10 hover:border-volt/40 transition-colors ${p.h}`}
                            >
                                <img
                                    src={p.src}
                                    alt={t.gallery.items[p.idx]}
                                    loading="lazy"
                                    className="w-full h-full object-cover contrast-[1.06] brightness-[0.96] group-hover:scale-[1.05] transition-transform duration-700 ease-out"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/85 via-transparent to-transparent pointer-events-none" />
                                <span className="absolute top-4 right-4 font-mono text-[10px] text-volt/80 bg-obsidian/70 backdrop-blur px-2.5 py-1 rounded-full border border-white/10">
                                    {i + 1}/5
                                </span>
                                <figcaption className="absolute bottom-4 left-4 flex items-center gap-2.5 bg-obsidian/80 backdrop-blur border border-volt/25 rounded-lg px-3.5 py-2">
                                    <span className="w-1.5 h-1.5 rounded-full bg-volt" />
                                    <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-200">
                                        {t.gallery.items[p.idx]}
                                    </span>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
